import MUIDialogContent from '@material-ui/core/DialogContent';
import { ResponsiveSpaceValue, space } from 'styled-system';
import { styled } from '~ui-kit/styled-components';

export const DialogContent = styled(MUIDialogContent)<{ $padding: ResponsiveSpaceValue }>`
  &.MuiDialogContent-root {
    display: flex;
    flex-direction: column;

    ${(props) => space({ p: props.$padding })};

    &:first-child {
      ${(props) => space({ pt: props.$padding })};
    }
  }
`;
